import Image from 'next/image';
import React from 'react';
import Button from '../../base-components/button/Button';
import {
  locationDeniedIconUrl,
  locationDeniedIconAlt,
  permissionDeniedTitle,
  permissionDeniedSubtext,
  permissionDeniedActionButton,
} from '../store/LocationAccuracyStore';

export const AutoDetectLocationErrorCmpDesktop: React.FC<{
  message: string | null;
  onSearchClick: () => void;
}> = ({ message, onSearchClick }) => (
  <div className="flex flex-col items-center justify-center px-[2.4rem] mt-[2.8rem]">
    <Image
      src={locationDeniedIconUrl}
      alt={locationDeniedIconAlt}
      width={112}
      height={112}
      priority={true}
    />
    <div className="text-center text-[1.4rem] font-semibold mt-[0.8rem] text-[#1B2531]">
      {permissionDeniedTitle}
    </div>
    <div className="text-center text-[1.2rem] mt-[0.4rem] text-[#707582]">
      {permissionDeniedSubtext}
    </div>
    <Button
      identifiers={{ id: 'permission-denied-action' }}
      interactions={{ onClick: onSearchClick }}
      type="button"
      className="w-full mt-[2.3rem] mx-[0.8rem] py-[0.8rem] border-[1px] border-[#0A57FF] text-[#0A57FF] text-[1.4rem] font-semibold text-center rounded-[0.4rem]"
    >
      {permissionDeniedActionButton}
    </Button>
  </div>
);
